<section
  class="aurora-ribbon"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-speed-input]="speed"
  [style.--scene-intensity-input]="intensity"
>
  <div class="aurora-backdrop"></div>

  <div
    *ngFor="let layer of layers"
    class="aurora-layer"
    [style.--layer-index]="layer"
  ></div>
</section>
